<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('studentFollowUpReport.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('studentFollowUpReport.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>{{ $t('studentFollowUpReport.criteria') }}</legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('studentFollowUpReport.rangeDate')
                      }}</label>
                      <a-range-picker
                        format="DD-MM-YYYY"
                        :defaultValue="rangeDate"
                        :defaultPickerValue="rangeDate"
                        @change="dateRangeChange"
                      >
                        <template slot="renderExtraFooter"></template>
                      </a-range-picker>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('studentFollowUpReport.branchName')
                      }}</label>
                      <a-select
                        style="width: 100%"
                        v-model.number="model.branch_id"
                        :options="branches"
                      ></a-select>
                      <div class="validate" v-if="errors.has('branch_id')">
                        {{ errors.first('branch_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('studentFollowUpReport.actionStatus')
                      }}</label>
                      <a-select v-model="model.action_status" class="ts-w-full">
                        <a-select-option value="all">All</a-select-option>
                        <a-select-option value="Follow Up"
                          >Follow Up</a-select-option
                        >
                        <a-select-option value="Accepted"
                          >Accepted</a-select-option
                        >
                        <a-select-option value="Rejected"
                          >Rejected</a-select-option
                        >
                      </a-select>
                      <div class="validate" v-if="errors.has('branch_id')">
                        {{ errors.first('branch_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{
                        $t('studentFollowUpReport.responsibleBy')
                      }}</label>
                      <a-select
                        v-model="model.responsible_by"
                        mode="multiple"
                        :options="employees"
                        placeholder="All"
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        class="ts-w-full"
                      ></a-select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label>{{
                        $t('studentEnrollmentReport.reportType')
                      }}</label>
                      <div class="form-group">
                        <div class="radio radio-css radio-inline">
                          <input
                            v-model="model.report_type"
                            type="radio"
                            id="summary"
                            :value="'summary'"
                          />
                          <label for="summary">
                            {{ $t('report.summary') }}
                          </label>
                        </div>
                        <div class="radio radio-css radio-inline">
                          <input
                            v-model="model.report_type"
                            type="radio"
                            id="detail"
                            :value="'details'"
                          />
                          <label for="detail">{{ $t('report.detail') }} </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-right">
                      <ts-button
                        class="btn-block"
                        color="primary"
                        @click.prevent="preview"
                        :waiting="waiting"
                        >{{ $t('preview') }}</ts-button
                      >
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('infoInquiry.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'infoInquiry',
  data () {
    return {
      loading: false,
      waiting: false,
      src: '',
      errors: new Errors(),
      branches: [],
      employees: [],
      rangeDate: [moment(), moment()],
      model: {
        branch_id: null,
        action_status: 'all',
        responsible_by: undefined,
        report_type: 'summary'
      }
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    responsibleLists () {
      if (this.employees.length > 0) {
        return this.employees.map(el => ({
          value: el.staff_id,
          label: el.name_en
        }))
      }
      return []
    }
  },
  methods: {
    ...mapActions('reportAcademic', [
      'getBranch',
      'studentFollowUp',
      'getEmployees'
    ]),
    async fetchData () {
      this.loading = true
      await this.getBranch().then(response => {
        this.branches = response.data.map(el => ({
          value: el.branch_id,
          label: el.branch_name_en
        }))
        this.model.branch_id = this.$store.state.authUser.default_branch_id
      })

      await this.getEmployees().then(response => {
        this.employees = response.data.map(el => ({
          value: el.staff_id,
          label: el.name_en + (el.name_kh ? '|' + el.name_kh : '')
        }))
      })

      this.loading = false
    },
    preview () {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.studentFollowUp(this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    dateRangeChange (dateRange) {
      this.$store.commit(
        'reportAcademic/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'reportAcademic/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
    }
  }
}
</script>
